export const ADD_TO_CALENDAR_LABEL = 'Add to calendar';
export const CALENDAR_FILENAME = 'calendar.ics';
